import { Component, HostListener, Injector, Input, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { jkRestReturn } from '../services/jkInterface';
import { BasePage } from '../services/base-page';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { entityState } from '../services/jkEntityTypes';


@Component({
  standalone: true,
  selector: 'app-jk-dialog-edit',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class JkDialogEditComponent<TSrv, TTable> extends BasePage {
  dialogRef = inject<MatDialogRef<JkDialogEditComponent<TSrv, TTable>>>(MatDialogRef);
  data = inject<jkRestReturn>(MAT_DIALOG_DATA);

  @HostListener('document:keydown', ['$event'])
  async handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      if (!this.isTopDialog()) {
        return;
      }
      let bool = await this.showConfirm('', '確定要離開?');
      if (bool) {
        this.doCancel(event);
      }
    }
  }

  private isTopDialog(): boolean {
    let openDialogs = this.dialog.openDialogs;
    return openDialogs.length === 0 || openDialogs[openDialogs.length - 1] === this.dialogRef;
  }
  modal_header!: ModalHeaderComponent; // ###
  modalHeaderReady($event: any) {
    this.modal_header = $event;
  }

  isDialog: boolean = true;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() srv!: any; // JkEntityV2;// 不是跑dialog的話,就要在外面設定
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() ownForm: any;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() isReadOnly: boolean = false;
  /*get item(): TTable {
    let r = {} as TTable;
    if (this.srv) return this.srv.item;
    else return r; // undefined;
  }*/
 item:TTable = {} as TTable; // 這樣才不會undefined.
  /* 虛欄位抓這裡.this.item 不是any,是table實欄位 */
  get itemAny(): any {
    return this.item;
  }
  get isBrowse(): boolean {
    if (this.srv)
      return this.srv.state === entityState.dsBrowse
    else
      return true;
  }
  _state: entityState = entityState.dsBrowse;
  get state(): entityState {
    if (this.srv)
      return (this.srv as any).state;
    return entityState.dsBrowse;
  }
  set state(st: entityState) {
    this._state = st;
    if (this._state === entityState.dsBrowse) {
      this.isReadOnly = true;
    } else {
      this.isReadOnly = false;
    }
  };
  constructor();
  constructor(injector: Injector, dialogRef: MatDialogRef<JkDialogEditComponent<TSrv, TTable>>, data: jkRestReturn);
  constructor() {
    const injector = inject(Injector);
    const dialogRef = inject<MatDialogRef<JkDialogEditComponent<TSrv, TTable>>>(MatDialogRef);
    const data = inject<jkRestReturn>(MAT_DIALOG_DATA);

    super(injector);
    this.dialogRef = dialogRef;
    this.data = data;

    dialogRef.disableClose = true;
    if (this.data && this.data.obj) {
      if (this.data.obj.masterSrv) {
        this.ownForm = this.data.obj;
        if (this.ownForm)
          this.title = this.ownForm.title;
        this.srv = this.data.obj.masterSrv;
        this.cloneField(this.srv.item,this.item);

        //console.log('jkDialogEdit get ownForm and srv');
      } else {
        this.srv = this.data.obj;
        console.log('jkDialogEdit get srv,no ownForm');
      }
    }
  }
  async doOk(e: any): Promise<boolean> {
    //let bool = await super.doOk(e);
    const ownFormCdr = this.ownForm?.cdr;
    ownFormCdr?.detach();
    try {
      return await new Promise<boolean>((resolve) => {
        window.setTimeout(async () => {
          this.cloneField(this.item,this.srv.item);
          let bool = await (this.srv as any).doUIOk();
          if (bool) {
            this.dialogRef.close(true);
          }
          resolve(bool);
        });
      });
    } finally {
      window.setTimeout(() => {
        ownFormCdr?.reattach();
        ownFormCdr?.detectChanges();
      });
    }
  }
  doCancel(e: any): boolean {
    //let bool = super.doCancel(e);
    let bool = (this.srv as any).doUICancel();
    if (bool) {
      this.dialogRef.close(false);
    }
    return bool;
  }
}
